// Class: motion.actuators.FilterActuator

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $import = require("./../../import_stub").default;
var $extend = require("./../../extend_stub").default;
function motion_actuators_SimpleActuator() {return require("./../../motion/actuators/SimpleActuator");}
function Reflect() {return require("./../../Reflect");}
function motion_actuators_PropertyDetails() {return require("./../../motion/actuators/PropertyDetails");}
function Std() {return require("./../../Std");}
function Type() {return require("./../../Type");}

// Constructor

var FilterActuator = function(target,duration,properties) {
	this.filterIndex = -1;
	(motion_actuators_SimpleActuator().default).call(this,target,duration,properties);
	if((Std().default)["is"](properties.filter,$hxClasses["Class"])) {
		this.filterClass = properties.filter;
		if(target.get_filters().length == 0) {
			target.set_filters([(Type().default).createInstance(this.filterClass,[])]);
		}
		var _g = 0;
		var _g1 = target.get_filters();
		while(_g < _g1.length) {
			var filter = _g1[_g];
			++_g;
			if((Std().default)["is"](filter,this.filterClass)) {
				this.filter = filter;
			}
		}
	} else {
		this.filterIndex = properties.filter;
		this.filter = target.get_filters()[this.filterIndex];
	}
}

// Meta

FilterActuator.__name__ = ["motion","actuators","FilterActuator"];
FilterActuator.__isInterface__ = false;
FilterActuator.__super__ = (motion_actuators_SimpleActuator().default);
FilterActuator.prototype = $extend((motion_actuators_SimpleActuator().default).prototype, {
	apply: function() {
		var _g = 0;
		var _g1 = (Reflect().default).fields(this.properties);
		while(_g < _g1.length) {
			var propertyName = _g1[_g];
			++_g;
			if(propertyName != "filter") {
				(Reflect().default).setProperty(this.filter,propertyName,(Reflect().default).field(this.properties,propertyName));
			}
		}
		this.setFilter();
	},
	initialize: function() {
		var details;
		var start;
		var _g = 0;
		var _g1 = (Reflect().default).fields(this.properties);
		while(_g < _g1.length) {
			var propertyName = _g1[_g];
			++_g;
			if(propertyName != "filter") {
				start = this.getField(this.filter,propertyName);
				details = new (motion_actuators_PropertyDetails().default)(this.filter,propertyName,start,(Reflect().default).field(this.properties,propertyName) - start,(Reflect().default).hasField(this.filter,"set_" + propertyName));
				this.propertyDetails.push(details);
			}
		}
		this.detailsLength = this.propertyDetails.length;
		this.initialized = true;
	},
	setFilter: function() {
		var filters = this.target.get_filters();
		if(this.filterIndex > -1) {
			filters[this.filterIndex] = this.filter;
		} else {
			var _g1 = 0;
			var _g = filters.length;
			while(_g1 < _g) {
				var i = _g1++;
				if((Std().default)["is"](filters[i],this.filterClass)) {
					filters[i] = this.filter;
				}
			}
		}
		this.setField(this.target,"filters",filters);
	},
	update: function(currentTime) {
		(motion_actuators_SimpleActuator().default).prototype.update.call(this,currentTime);
		this.setFilter();
	}
});
FilterActuator.prototype.__class__ = FilterActuator.prototype.constructor = $hxClasses["motion.actuators.FilterActuator"] = FilterActuator;

// Init



// Statics




// Export

exports.default = FilterActuator;